import { Component } from '@angular/core';
import { Mode } from '../../components/confirmation-code/mode.service';

@Component({
  selector: 'auth-recovery-password-confirmation-code',
  templateUrl: './recovery-password-confirmation-code.component.html',
  styleUrls: ['./recovery-password-confirmation-code.component.scss']
})
export class RecoveryPasswordConfirmationCodeComponent {

  mode: Mode = Mode.RECOVERY;

  constructor() { }

}
